// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wrap {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n\n.ad-wrap {\n  width: 100%;\n  height: calc(100% - 58px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.inner-wrap {\n  height: 280px;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
